import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import {
  combinedLightTheme,
  combinedDarkTheme,
} from '../design-system/tokens';

const getUiTheme = (state: any) => state.uiTheme || {};

const getCurrentTheme = (state: any) => state.uiTheme?.currentTheme || 'light';

export const getTheme = createSelector(
  [getUiTheme, getCurrentTheme],
  (legacyTheme, currentTheme) => {
    const designTokens = currentTheme === 'dark' ? combinedDarkTheme : combinedLightTheme;

    return {
      ...legacyTheme, // All existing colors, sizes, fonts
      ...designTokens, // New design tokens: color, spacing, typography, radius
    };
  }
);

const mapStateToProps = (state) => ({
  theme: getTheme(state),
});

const connectTheme = (component) => connect(mapStateToProps)(component);

export default connectTheme;
